module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "scene-container"
  }, [_c('svg', [_c('g', {
    ref: "scene"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-63363b71!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WordsCloudRenderer.vue
// module id = 122
// module chunks = 2